import * as msal from "@azure/msal-browser";
const msalConfig = {
  auth: {
    clientId: "d386ba63-1e32-4c18-9cfb-37837a3172b3",
    authority: "https://login.microsoftonline.com/RightwayUPC.onmicrosoft.com",
    redirectUri:
      process.env.NODE_ENV === "production"
        ? "https://rightwayupc.ca/"
        : "http://localhost:8080/",
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};
const MsalInstance = {
  install(vue) {
    //debugger;
    vue.prototype.$msalInstance = new msal.PublicClientApplication(msalConfig);
  },
};
export default MsalInstance;
